// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8983":"d82592fa","9782":"d46f857e"}[chunkId] + ".chunk.css";
};